import { Component, OnInit , trigger, state, style, transition, animate ,Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Config } from "./app.config";
import { Layer } from "./models/layer.model";
import { Thematic } from "./models/thematic.model";
import { UrlParamsService } from "./services/utils/url-params.service";
import * as $ from 'jquery';
import * as bootstrap from 'bootstrap';


window["$"] = $;
window["jQuery"] = $;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']

})

export class AppComponent implements OnInit{



  /**/
  constructor() {

  }
  ngOnInit() {

  }


}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/app.component.ts